import { create } from 'zustand';

export type ChartCard = {
  id: string;
  title: string;
  chart_type: 'pie' | 'bar' | 'line' | 'scatter' | 'histogram' | 'donut';
  rows: Array<Record<string, unknown>>;
  group_by?: string;
  stats_field?: string;
  stats_op?: string;
  out_fields?: string[];
};

type WidgetState = {
  charts: ChartCard[];
  addChart: (card: ChartCard) => void;
  removeChart: (id: string) => void;
  clearCharts: () => void;
};

let counter = 0;

export const useWidgetStore = create<WidgetState>((set) => ({
  charts: [],
  addChart: (card) => set((s) => ({ charts: [...s.charts, card] })),
  removeChart: (id) =>
    set((s) => ({ charts: s.charts.filter((c) => c.id !== id) })),
  clearCharts: () => set({ charts: [] }),
}));

export function nextChartId(): string {
  counter += 1;
  return `chart_${counter.toString(36)}`;
}
